import { useCurrentSessionId } from '@heidi/runtime/shell';

import { MIN_SESSION_MERGE_TAB_MEMBERS } from '../../contracts';
import { useQuerySessionById } from '../../data/query/useQuerySessionById';

/**
 * Whether the open session renders a Session Merge tab — i.e. the tab
 * coachmark's anchor is (or is about to be) in the DOM. Mirrors the tab's own
 * visibility in `useStaticTabs`: a ≥2-member group (a ≤1-member group is
 * treated as having no active merge). Off a session route
 * `useCurrentSessionId()` is empty, so the query is disabled and this is
 * `false`.
 *
 * Gates the tab coachmark's enqueue: without it the coachmark (a `null`-render
 * until its anchor exists) would sit at the head of the LOW-priority modal
 * queue on every tab-less screen and block sibling spotlights, since the queue
 * shows one modal at a time and nothing dequeues an invisible one.
 */
export function useOpenSessionHasMergeTab(): boolean {
  const sessionId = useCurrentSessionId();
  const { data: groupMemberCount = 0 } = useQuerySessionById({
    sessionId,
    select: (data) => data?.session_merge_group?.members?.length ?? 0,
  });

  return groupMemberCount >= MIN_SESSION_MERGE_TAB_MEMBERS;
}
